import { render } from "./MyCompanyAddress_CH.vue?vue&type=template&id=4f363728"
import script from "./MyCompanyAddress_CH.vue?vue&type=script&lang=js"
export * from "./MyCompanyAddress_CH.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__